import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ISession } from '../../../models/session';
import { SessionsService } from '../sessions.service';
import { SessionBase } from '../session-base';
import { tap } from 'rxjs/operators';

@Component({
  template: `<customization [type]="type" [session]="session"></customization>`
})
export class SessionsCustomizationComponent extends SessionBase implements OnInit {
  public session: ISession;
  public type;

  constructor(private route: ActivatedRoute, private router: Router, private sessionService: SessionsService) {
    super();
  }

  ngOnInit() {
    super
      .getSession$(this.route.parent.data)
      .pipe(tap(session => (this.type = session.types.sessionType)))
      .subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/customization/customization.component.ts